/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DisplayPromoCode_user$ref = any;
export type ItemDisplayPromoCodeWrapper_user$ref = any;
export type ItemDisplayPromoCodeWrapper_user = {
    readonly " $fragmentRefs": DisplayPromoCode_user$ref;
    readonly " $refType": ItemDisplayPromoCodeWrapper_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemDisplayPromoCodeWrapper_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DisplayPromoCode_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'eaf60c69f01711c854883219d890377c';
export default node;
